module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_C_2.52af34a2.mp3";